<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>编辑商品</h3>
                </el-col>
            </el-row>
        </div>
        <el-form label-width="150px" :model="productForm" ref="productForm" :rules="addProductRules">
            <div class="block">
                <h2>商品分类：</h2>
                <el-form-item label="选择商品分类" prop="categoryId">
                    <el-select v-model="productForm.categoryId" placeholder="分类">
                        <el-option v-for="item in catogreyArr" :key="item.categoryId" :label="item.name" :value="item.categoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品标签">
                    <el-select v-model="topic" multiple filterable allow-create placeholder="标签">
                        <el-option v-for="item in topicArr" :key="item.tagId" :label="item.name" :value="item.tagId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <div class="block">
                <h2>基本信息：</h2>
                <el-form-item label="商品名称" prop="name">
                    <el-input v-model="productForm.name" placeholder="商品名"></el-input>
                </el-form-item>
                <el-form-item label="商品描述">
                    <el-input v-model="productForm.description" placeholder="商品描述"></el-input>
                </el-form-item>
                <el-form-item label="商品押金" prop="deposit">
                    <el-input v-model="productForm.deposit" placeholder="商品押金"></el-input>
                </el-form-item>
                <el-form-item label="起租的每日租金" prop="rental">
                    <el-input v-model="productForm.rental" placeholder="起租的每日租金"></el-input>
                </el-form-item>
                <el-form-item label="原租金价格">
                    <el-input v-model="productForm.oldRental" placeholder="原租金价格"></el-input>
                </el-form-item>
                <el-form-item label="起租天数设置" prop="minimumDay">
                    <el-input v-model="productForm.minimumDay" placeholder="起租天数设置"></el-input>
                </el-form-item>
                <el-form-item label="后续价格" prop="rentalMore">
                    <el-input v-model="productForm.rentalMore" placeholder="后续价格"></el-input>
                </el-form-item>
                <el-form-item label="上传商品橱窗图片">
                    <el-upload action="https://upload.qiniup.com/" :file-list="fileListPic" :on-error="handleError" list-type="picture-card" :on-preview="handlePicCardPreview" :on-remove="handleRemove" :on-success="handlePicSuccess" :before-upload="beforePicUpload" :data="uptoken">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog v-model="dialogVisible" size="tiny">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="视频链接(选填)">
                    <el-input v-model="productForm.media.video" placeholder="视频链接"></el-input>
                </el-form-item>
                <el-form-item label="上传视频封面图(选填)">
                    <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-error="handleError" :on-remove="handleVideoRemove" :on-success="handleVideoSuccess" :before-upload="beforeDetailUpload" :data="uptoken">
                        <img v-if="productForm.media.videoThumb" :src="productForm.media.videoThumb" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="商品清单">
                    <el-col :span="6">
                        <el-input v-model="list.name" placeholder="名称"></el-input>
                    </el-col>
                    <el-col class="line" :span="1" style="text-align: center;border: 0">*</el-col>
                    <el-col :span="6">
                        <el-input v-model="list.count" placeholder="数量"></el-input>
                    </el-col>
                    <el-col :span="2" style="margin-left: 10px;">
                        <el-button type="success" @click="addList">添加</el-button>
                    </el-col>
                </el-form-item>
                <el-form-item label="" v-if="productForm.inventory.length">
                    <div v-for="(item,index) in productForm.inventory" :key="index">
                        <p>{{++index}}、{{item[0]}}*{{item[1]}} <el-button type="danger" @click="removeThis(index)" style="margin-left: 20px">删除</el-button></p>
                    </div>
                </el-form-item>
                <el-form-item label="是否提供PlayCare保险服务">
                    <el-radio class="radio" v-model="insurance" label="1">提供</el-radio>
                    <el-radio class="radio" v-model="insurance" label="0">不提供</el-radio>
                    <el-input style="margin-left: 20px;width: 200px" v-if="insurance === '1'" v-model="productForm.insurance" placeholder="如果提供请输入价格(单位：分)"></el-input>
                </el-form-item>
                <el-form-item label="上传商品详情图">
                    <el-upload action="https://upload.qiniup.com/" :file-list="fileListDetail" :on-error="handleError" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleDetailRemove" :on-success="handleDetailSuccess" :before-upload="beforeDetailUpload"
                        :data="uptoken">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog v-model="dialogVisible" size="tiny">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="选配设置">
                    <el-select v-model="value10" multiple filterable allow-create placeholder="商品" style="width: 600px">
                        <el-option v-for="item in xuanpeiArr" v-if="item.isOnline" :key="item.productDetailId" :label="item.name" :value="item.productDetailId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="租赁设备类型">
                    <el-select v-model="productForm.zmRentType" style="width: 600px">
                        <el-option v-for="item,key in zmRentTypeMap"
                            :key="key"
                            :label="item"
                            :value="key">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <div class="block">
                <h2>享玩甄选设置</h2>
                <el-form-item label="">
                    <el-radio class="radio" v-model="zhenxuan" label="1">默认为首页的享玩甄选</el-radio>
                    <el-radio class="radio" v-model="zhenxuan" label="0">重新设置</el-radio>
                </el-form-item>
                <div v-if="zhenxuan != '1'">
                    <el-form-item label="享玩甄选描述" label-width="150px">
                        <el-input v-model="shopForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="商品选择" label-width="150px">
                        <el-select v-model="shopForm.productDetailId" placeholder="商品" @change="productChoose">
                            <el-option v-for="item in productArr" v-if="item.isOnline" :key="item.productDetailId" :label="item.name" :value="item.productDetailId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="当前租金(元)" label-width="150px" v-if="shopForm.product">
                        <el-input v-model="shopForm.product.rental" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="原租金(元)" label-width="150px" v-if="shopForm.product">
                        <el-input v-model="shopForm.product.oldRental"></el-input>
                    </el-form-item>
                    <el-form-item label="" label-width="150px">
                        <el-button type="success" @click="addShop">添加</el-button>
                    </el-form-item>
                    <el-form-item label="" label-width="150px" style="margin-bottom: 50px;overflow:hidden;">
                        <div v-for="(item,index) in productForm.pushProductDetails" :key="index">
                            <el-card class="box-card" style="width: 260px;margin-right:20px;float:left;">
                                <div slot="header" class="clearfix">
                                    <span style="line-height: 36px;">{{item.name}}</span>
                                    <el-button style="float: right;" type="danger" @click="removeCard(index)">删除</el-button>
                                </div>
                                <div class="text item">
                                    <p>当前租金：{{item.rental}}</p>
                                    <p>原来租金：{{item.oldRental}}</p>
                                </div>
                            </el-card>
                        </div>
                    </el-form-item>
                </div>
            </div>

            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">更新</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>

        </el-form>

    </div>
</template>

<script>
    import {
        getProductCategories,
        getProductTags,
        getProductAccessories,
        getProductDetailsId,
        putProductDetails,
        getProductDetails,
        postProductTag,
        postProductAccessories,
        getProductTagId,
        getProductAccessoriesId,
        deleteProductTag,
        deleteProductAccessories,
        getProductAccessoriesDetailId,
        getProductDetailsOnly,
        getProductTagAll
    } from '../../api/version'

    export default {
        data() {
            return {
                productForm: {
                    name: '',
                    accessoryType: '',
                    description: '',
                    rental: '',
                    oldRental: '',
                    minimumDay: '',
                    categoryId: '',
                    rentalMore: '',
                    isOnline: true,
                    media: {
                        video: '',
                        //橱窗图片
                        pic: [],
                        //商品详情图
                        detail: []
                    },
                    inventory: [],
                    insurance: '',
                    pushProductDetails: [],
                    fileListPic: []
                },
                //享玩甄选
                shopForm: {
                    price_current: '',
                    price_old: '',
                    name: '',
                    productDetailId: '',
                    product: '',
                },
                addProductRules: {
                    categoryId: [{
                        type: 'number',
                        required: true,
                        message: '请选择商品分类',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: '请填写商品名称',
                        trigger: 'blur'
                    }],
                    description: [{
                        required: true,
                        message: '请填写商品描述',
                        trigger: 'blur'
                    }],
                    deposit: [{
                        required: true,
                        message: '请填写商品押金',
                        trigger: 'blur'
                    }],
                    rental: [{
                        required: true,
                        message: '请填写商品的每日租金',
                        trigger: 'blur'
                    }],
                    oldRental: [{
                        required: true,
                        message: '请填写商品原租金价格',
                        trigger: 'blur'
                    }],
                    minimumDay: [{
                        required: true,
                        message: '请填写商品起租天数',
                        trigger: 'blur'
                    }],
                    rentalMore: [{
                        required: true,
                        message: '请填写商品后续价格',
                        trigger: 'blur'
                    }]
                },
                list: {},
                dialogImageUrl: '',
                dialogVisible: false,
                uptoken: {
                    token: sessionStorage.token
                },
                insurance: '',
                zhenxuan: '1',
                catogreyArr: [],
                topicArr: [],
                topic: '',
                value10: '',
                oldTopic: [],
                oldValue10: [],
                xuanpeiArr: [],
                productArr: [],
                fileListPic: [],
                fileListDetail: [],
                zmRentTypeMap: {
                    ZMSC_1_1_3: '数码摄像',
                    ZMSC_1_1_4: '配件',
                    ZMSC_1_1_5: '智能设备'
                }
            }
        },

        created() {
            //获取分类
            getProductCategories().then(res => {
                console.log(res, '分类')
                this.catogreyArr = res.data
            }, err => {
                console.log(err)
            })

            //获取商品标签
            getProductTags().then(res => {
                console.log(res, '标签')
                this.topicArr = res.data
            }, err => {
                console.log(err)
            })

            //获取当钱商品的数据
            getProductDetailsId(this.$route.params.id).then(res => {
                this.productForm = res.data
                this.productForm.deposit = this.productForm.deposit*100 + ''
                this.productForm.rental = this.productForm.rental*100 + ''
                this.productForm.oldRental = this.productForm.oldRental*100 + ''
                this.productForm.minimumDay = this.productForm.minimumDay + ''
                this.productForm.rentalMore = this.productForm.rentalMore*100 + ''
                this.productForm.zmRentType = res.data.zmRentType;
                if(this.productForm.insurance > 0) {
                    this.productForm.insurance = this.productForm.insurance*100 + ''
                }else{
                    this.productForm.insurance = null
                }

                if (this.productForm.insurance > 0) {
                    this.insurance = '1'
                } else {
                    this.insurance = '0'
                }
                if (this.productForm.pushProductDetails && this.productForm.pushProductDetails.length) {
                    this.zhenxuan = '0'
                }

                if (this.productForm.media.pic.length) {

                    this.productForm.media.pic.forEach(res => {
                        this.fileListPic.push({
                            url: res
                        })
                    })
                }

                if (res.data.media.detail.length) {
                    res.data.media.detail.forEach(res => {
                        this.fileListDetail.push({
                            url: res
                        })
                    })
                }
            })

            //获取当前商品的标签
            getProductTagAll(sessionStorage.userId, JSON.stringify({"where":{"productDetailId": this.$route.params.id},"include":"productTag"})).then(res => {
                console.log(res.data, 'bbb')
                if (res.data) {
                    res.data.forEach(item => {
                        this.oldTopic.push(item.id)
                        this.topic.push(item.tagId)
                    })
                }
            })

            //获取当前商品的选配
            getProductAccessoriesDetailId(sessionStorage.userId, JSON.stringify({'where':{'productDetailId': this.$route.params.id},'include':'accessory'}) ).then(res => {
                if (res.data) {
                    res.data.forEach(item => {
                        this.oldValue10.push(item.id)
                        this.value10.push(item.accessoryId)
                    })
                }
            })

            getProductDetailsOnly(sessionStorage.userId,JSON.stringify({where:{accessoryType: 0}})).then(res => {
                this.productArr = res.data
            })

            //获取选配列表
            getProductAccessories(sessionStorage.userId, JSON.stringify({'where':{'accessoryType': {'neq': 0}}})).then(res => {
                console.log(res, '选配')
                this.xuanpeiArr = res.data
            })
        },

        methods: {
            //添加商品清单
            addList() {
                if (this.list.name && this.list.count) {
                    this.productForm.inventory.push([this.list.name, this.list.count])
                    this.list = {
                        name: '',
                        count: ''
                    }
                }
            },
            //移除想玩甄选
            removeCard(index) {
                this.productForm.pushProductDetails.splice(index, 1)
            },
            handleVideoRemove(file, fileList) {

            },
             handleVideoSuccess(res, file) {
                this.productForm.media.videoThumb = `https://img.shareplay.cc/${res.key}`
            },
            //享玩甄选添加
            addShop() {
                if (!this.shopForm.name) {
                    this.$message.error('请填写描述')
                } else if (!this.shopForm.product) {
                    this.$message.error('请选择商品')
                } else {
                    let data = {
                        productDetailId: this.shopForm.productDetailId,
                        rental: this.shopForm.product.rental,
                        oldRental: this.shopForm.product.oldRental,
                        name: this.shopForm.name,
                        media: this.shopForm.product.media
                    }
                    if(!this.productForm.pushProductDetails){
                        this.productForm.pushProductDetails = []
                    }
                    this.productForm.pushProductDetails.push(data)
                    this.shopForm = {
                        price_current: '',
                        price_old: '',
                        name: '',
                        productDetailId: '',
                        product: '',
                    }
                }
            },
            productChoose(val) {
                console.log(val)
                this.productArr.forEach( item => {
                    if(item.productDetailId === val) {
                        this.shopForm.product = item
                    }
                })

            },
            handleRemove(file, fileList) {
                let arr = []
                fileList.forEach(item => {
                    if(item.response) {
                        arr.push(`https://img.shareplay.cc/${item.response.hash}`)
                    }else{
                        arr.push(item.url)
                    }

                })
                this.productForm.media.pic = arr
            },
            handleDetailRemove(file, fileList) {
                console.log(file);
                console.log(fileList[0].response);
                let arr = []
                fileList.forEach(item => {
                    if(item.response) {
                        arr.push(`https://img.shareplay.cc/${item.response.hash}`)
                    }else{
                        arr.push(item.url)
                    }

                })
                this.productForm.media.detail = arr
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handlePicCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            },
            handlePicSuccess(res, file) {
                this.productForm.media.pic.push(`https://img.shareplay.cc/${res.key}`)
            },
            beforePicUpload() {
                if (this.productForm.media.pic.length >= 6) {
                    this.$message({
                        message: '橱窗图片最多上传6张',
                        type: 'warning'
                    });
                    return false
                }
            },
            handleDetailSuccess(res, file) {
                this.productForm.media.detail.push(`https://img.shareplay.cc/${res.key}`)
            },
            beforeDetailUpload() {

            },
            onSubmit() {
                this.$refs['productForm'].validate((valid) => {
                    console.log(this.productForm)
                    console.log(this.value10, 't')
                    if (valid) {
                        //是否需要保险 1需要
                        if (this.insurance === '1' && !this.productForm.insurance) {
                            this.$message.error('请填写保险服务价格')
                        } else if (!this.productForm.media.pic.length) {
                            this.$message.error('请上传商品橱窗图片')
                        } else if (!this.productForm.media.detail.length) {
                            this.$message.error('请上传商品详情图片')
                        } else if (this.zhenxuan === '0' && (!this.productForm.pushProductDetails || !this.productForm.pushProductDetails.length)) {
                            this.$message.error('请添加享玩甄选设置')
                        } else {

                            if(this.zhenxuan === '1') {
                                this.productForm.pushProductDetails = null
                            }

                            putProductDetails(sessionStorage.userId, this.$route.params.id, this.productForm).then(res => {
                                if (res.data) {
                                    this.productForm.insurance = ''
                                    let result = res.data
                                    let topicArr = []
                                    let oldArr = []
                                    //商品和标签关联
                                    if (this.oldTopic.length) {
                                        this.oldTopic.forEach(item => {
                                            oldArr.push(deleteProductTag(sessionStorage.userId, item).then(res => {
                                                //delete
                                            }))
                                        })

                                    }

                                    if (this.oldValue10.length) {
                                        this.oldValue10.forEach(item => {
                                            oldArr.push(deleteProductAccessories(sessionStorage.userId, item).then(res => {
                                                //delete
                                            }))
                                        })

                                    }

                                    Promise.all(oldArr).then(res => {
                                        this.topic.forEach(item => {
                                            let data = {
                                                "tagId": item,
                                                "productDetailId": result.productDetailId
                                            }
                                            topicArr.push(postProductTag(sessionStorage.userId, data).then(res => {
                                                console.log(res.data, '标签')
                                            }))
                                        })

                                        this.value10.forEach(item => {
                                            let data = {
                                                "accessoryId": item,
                                                "productDetailId": result.productDetailId
                                            }
                                            topicArr.push(
                                                postProductAccessories(sessionStorage.userId, data).then(res => {
                                                    console.log(res)
                                                })
                                            )
                                        })

                                        Promise.all(topicArr).then(val => {
                                            this.$message({
                                                message: '恭喜你，成功添加商品',
                                                type: 'success'
                                            });
                                            this.$router.push('/list')
                                        })
                                    })




                                }

                            }, err => {
                                this.$message.error('添加失败')
                            })
                        }

                    }
                })

            },
            goBack() {
                this.$router.push('/list')
            },
            removeThis(index) {
                let _this = index
                this.productForm.inventory.splice(--_this, 1)
                console.log(index)
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// EditProduct.vue?0a538891